import { FC } from 'react';
import * as S from './Styles';

interface IModalProps {
  isOpen: boolean;
  children: any;
}
export const Modal: FC<IModalProps> = ({ isOpen, children }) => {
  return isOpen ? (
    <div data-tour="modal">
      <S.ModalContainer>
        <S.ModalBox>{children}</S.ModalBox>
      </S.ModalContainer>
    </div>
  ) : null;
};
